export default __webpack_public_path__ + "static/media/logo.8ed7ef87.webp";